import { AxiosError } from "axios";
import { BoardRunModel } from "models/BoardRunModel";
import { createContext } from "react";

export interface IBoardRunsContext {
  runs: BoardRunModel[];
  canAddRun: boolean;
  error?: AxiosError;
  isLoading: boolean;
  reloadBoardRuns: () => Promise<void>;
}

export const BoardRunsContext = createContext({} as IBoardRunsContext);
